/* eslint-disable max-classes-per-file */
import { CustomError } from 'ts-custom-error';

import { setClassName } from '@change-corgi/core/error';

export class TimeoutError extends CustomError {}
setClassName(TimeoutError, 'TimeoutError');

export class JobFailedError extends CustomError {}
setClassName(JobFailedError, 'JobFailedError');

export class JobCreateError extends CustomError {}
setClassName(JobCreateError, 'JobCreateError');
